import React, { useRef } from "react";
import { Button, Card, Divider, Dropdown, Menu, Tabs, Modal } from "antd";
import { ProfileTwoTone } from "@ant-design/icons";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import SoForm from "./SoForm";
import SoDetailList from "./SoDetailList";
import { useModel, useModelDispatchers } from "../../../models";
import PaymentDrawer from "./PaymentDrawer";
import { goPage } from "../../layout/pageDefinition";
import { useHistory } from "react-router";
import UpOutlined from "@ant-design/icons/lib/icons/UpOutlined";
import DownOutlined from "@ant-design/icons/lib/icons/DownOutlined";
import SoPrint from "./SoPrint";
import SoPrint1 from "./SoPrint1";
import { debounce } from "lodash";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const history = useHistory();
    const formRef = useRef();
    const printRef = useRef();
    const printRef1 = useRef();

    const { closeNav } = useModelDispatchers("nav");
    const [{
        selectedDocument,
        formExpand
    }, {
        disable,
        whConfirm,
        setPaymentDrawerVisible,
        toggleExpand,
        loadSo
    }] = useModel("saleSo");
    const [{ preview }, { setPreview }] = useModel("global")

    const { orderStatus } = selectedDocument;

    const getForm = () => {
        return formRef && formRef.current ? formRef.current.form() : null
        // return formRef.current.form();
    };

    const onPrint = () => {
        setPreview({
            visible: true,
            __html: printRef.current.dom().innerHTML
        })
    }
    const onPrint1 = () => {
        setPreview({
            visible: true,
            __html: printRef1.current.dom().innerHTML
        })
    }
    const onDisable = () => {
        Modal.confirm({
            title: "确认作废此单据？",
            centered: true,
            closable: true,
            onOk: () => {
                const { id: data } = selectedDocument;
                disable({ showMsg: true, data })
            },
            onCancel: () => { }
        });
    }
    const onWhConfirm = async () => {
        /*const {id: data} = selectedDocument;
        whConfirm({showMsg: true, data})*/
        let ret = await formRef.current.update()
        if (ret) {
            const { id: data } = selectedDocument;
            await whConfirm({ showMsg: true, data })
            await onRefresh()
        }
    }
    const onSettle = () => {
        setPaymentDrawerVisible(true);
    }
    const onSave = async () => {
        await formRef.current.update();
        await onRefresh();
    }
    const onBack = () => {
        closeNav();
        goPage(history, "3-2");
    }
    const onRefresh = async () => {
        const { id } = selectedDocument;
        await loadSo({ showMsg: true, data: id })
    }
    const onToggleExpand = () => {
        toggleExpand();
    }
    const printStyleMenu = (
        <Menu>
            <Menu.Item key="1" onClick={onPrint}>服务站样式</Menu.Item>
            <Menu.Item key="2" onClick={onPrint1}>普通样式</Menu.Item>
        </Menu>
    );

    const Title = () => {
        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">销售单</span>
                    <span
                        className="margin-left-16"
                    >
                        {selectedDocument.saleCode} [{selectedDocument.orderStatusName}]
                    </span>
                    <span
                        className="margin-left-16"
                        onClick={onToggleExpand}
                        style={{ cursor: "pointer" }}
                    >
                        {formExpand ? <UpOutlined /> : <DownOutlined />}
                        <span className="margin-left-8 color-red ">{selectedDocument.isReplenish ? "已补单" : ""}</span>
                    </span>
                </h3>
                <div style={{ width: "600px", textAlign: "right" }}>
                    <YhAuth resCode={ResourceAuthEnum.S_ED_CANCEL}>
                        <Button
                            onClick={onDisable}
                            disabled={orderStatus !== "017001"}
                        >
                            作废
                    </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.S_ED_PRINT}>
                        <Dropdown className="margin-left-8" overlay={printStyleMenu}>
                            <Button>
                                打印 <DownOutlined />
                            </Button>
                        </Dropdown>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.S_ED_BILL}>
                        <Button
                            className="margin-left-8"
                            onClick={onSettle}
                            disabled={
                                !(orderStatus === "017001"
                                    || orderStatus === "017002")
                            }
                        >
                            结算
                    </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.S_ED_CONFIRM}>
                        <Button
                            className="margin-left-8"
                            onClick={debounce(onWhConfirm, 600)}
                            disabled={
                                !(orderStatus === "017002"
                                    || orderStatus === "017003")
                            }
                        >
                            库房确认
                    </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.S_ED_SAVE}>
                        <Button
                            className="margin-left-8"
                            type="primary"
                            onClick={debounce(onSave, 600)}
                            disabled={
                                orderStatus === "017005"
                                || orderStatus === "017004"
                                || orderStatus === "017003"
                            }
                        >
                            保存
                    </Button>
                    </YhAuth>
                    <Button
                        className="margin-left-8"
                        onClick={debounce(onRefresh, 600)}
                    >
                        刷新
                    </Button>
                    <Button
                        className="margin-left-8"
                        onClick={onBack}
                    >
                        返回
                    </Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            title={<Title />}
            bordered={true}
            className="margin-top-8"
        >
            <SoForm formRef={formRef} actionType={CM_ACTION_TYPE.EDIT} />
            <Divider orientation="left" />
            <SoDetailList getForm={getForm} />

            <PaymentDrawer formInstance={() => formRef?.current.form()} />

            <SoPrint printRef={printRef} />
            <SoPrint1 printRef={printRef1} />
        </Card>
    );
}